import { selectMerchant } from "@redux";
import { useNotify } from "@utils";
import { Button, Modal } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import OtpInput from "react-otp-input";
import { useSelector } from "react-redux";
import styled from "styled-components";
interface IProps {
    handleCloseDetail: () => void;
    removeCard: () => void;
}

export const ComponentRemoveCardModal = (props: IProps) => {
    //page hooks
    const { t } = useTranslation();
    const { error } = useNotify();
    //redux states
    const { themes } = useSelector(selectMerchant);
    const [step, setStep] = useState<number>(0);
    //page redux
    const { handleCloseDetail, removeCard } = props;

    const [otp, setOtp] = useState<string>("");
    const handleChangeOtp = (otp: string) => {
        setOtp(otp);
    };

    const onRemoveCard = () => {
        if (step === 0) {
            setStep(1);
        } else if (step === 1) {
            if (otp.toLocaleLowerCase() !== "delete") {
                error(`Please Type "delete"`);
            } else {
                removeCard();
            }
        }
    };

    return (
        <Modal
            footer={null}
            visible={true}
            onCancel={handleCloseDetail}
            closable={false}
            width={400}
            className="remove-modal"
        >
            <StyledModal themeColor={themes?.themeColor!}>
                {step === 0 && (
                    <div>
                        <p className="title">Do you want to remove this card?</p>
                        <p className="desc">
                            The card will be removed from your account. This action cannot be
                            undone.
                        </p>
                    </div>
                )}
                {step === 1 && (
                    <div>
                        <p className="title">
                            Please type the word “delete” to confirm card removal.
                        </p>
                        <OtpInput
                            numInputs={6}
                            inputStyle={{
                                width: "3rem",
                                height: "50px",
                                margin: "5px",
                                fontSize: "1rem!important",
                                borderRadius: "4px",
                                border: "1px solid #e1e1e1",
                                background: "inherit",
                                textTransform: "uppercase",
                                fontWeight: "600",
                                // color: `${themeMode === "dark" ? "white" : "dark"}`,
                            }}
                            containerStyle={{
                                justifyContent: "center",
                                flexWrap: "wrap",
                                margin: "32px 0",
                            }}
                            // isInputNum
                            onChange={handleChangeOtp}
                            value={otp}
                        />
                    </div>
                )}

                <div className="btn-section">
                    <Button className="btn cancel" onClick={handleCloseDetail}>
                        {t("page.cancel")}
                    </Button>
                    <Button className="btn confirm" onClick={onRemoveCard}>
                        {t("page.confirm")}
                    </Button>
                </div>
            </StyledModal>
        </Modal>
    );
};
const StyledModal = styled.div<{ themeColor: string }>`
    text-align: center;
    border-radius: 16px;
    overflow: hidden;
    .title {
        margin-top: 20px;
        margin-bottom: 0;
        font-size: 18px;
        font-weight: 600;
        color: #946037;
    }
    .desc {
        margin: 32px 0;
        font-size: 14px;
        color: #919191;
        font-weight: 500;
    }
    input {
        color: red;
    }

    .btn-section {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-gap: 15px;
        .btn {
            width: 100%;
            height: 48px;
            border-radius: 500px;
        }
        .cancel {
            border: 1px solid ${(p) => p.themeColor};
            color: ${(p) => p.themeColor};
            background-color: #fff;
        }
        .confirm {
            color: white;
            background-color: ${(p) => p.themeColor};
        }
    }
`;
